
/**
 * Centralized definition of all tracking events.
 * specific strings for analytics providers to ensure consistency.
 */
export const TRACKING_EVENTS = {
  CRM_AUTH: "crm_auth", // When a user switches a company from company selector
  ADD_LEAD: "add_lead", // When a user clicks on "Add Lead" button
  SAVE_LEAD: "save_lead", // When a user clicks on the "Save" button from the add lead view
  IMPORT_LEAD: "import_lead", // When a user clicks on "import" button in the lead view
  EXPORT_LEAD: "export_lead", // When a user clicks on "export" button in the lead view
  CREATE_LIST: "create_list", // When a user clicks on "create list" button in the lead list view
  ADD_AUTOMATION: "add_automation", // When a user clicks on "Add Automation" button in the automation view
  START_FROM_SCRATCH_AUTOMATION: "start_from_scratch_automation", // When a user clicks on "Start from Scratch" button in the automation view
  SELECT_AUTOMATION_TEMPLATE: "select_automation_template", // When a user clicks on any template in the automation view

  // Triggers
  AUTOMATION_TRIGGER_LEAD: "automation_trigger_lead", // When a user selects lead triggers
  AUTOMATION_TRIGGER_APPOINTMENTS: "automation_trigger_appointments", // When a user selects appointment triggers
  AUTOMATION_TRIGGER_COMMUNICATION: "automation_trigger_communication", // When a user selects communication triggers

  // Automation Flows
  SELECT_AUTOMATION_TEMPLATE_CREATE_VIEW:
    "select_automation_template_create_view", // When a user clicks on any template in the automation create view
  FINISH_AUTOMATION: "finish_automation", // When a user clicks on "Finish" button when creating an automation
  SAVE_AUTOMATION: "save_automation", // When a user clicks on "Save Automation" button when creating an automation

  // Appointments
  ADD_APPOINTMENT: "add_appointment", // When a user clicks on "Add Appointment" button when creating an appointment
  CREATE_APPOINTMENT: "create_appointment", // When a user clicks on "Create Appointment" button when creating an appointment

  // Tasks
  ADD_TASK: "add_task", // When a user clicks on "Add Task" button when creating a task
  SAVE_TASK: "save_task", // When a user clicks on "Save" button when creating a task
};

/**
 * Event property values or sub-types for triggers.
 */
export const TRIGGER_TYPES = {
  LEAD: {
    CREATED: 'lead_created',
    ASSIGNED: 'lead_assigned',
    TAG: 'lead_tag',
    STATUS: 'lead_status',
    SCORE: 'lead_score',
    SOURCE: 'lead_source'
  },
  APPOINTMENTS: {
    SCHEDULED: 'appointment_scheduled',
    COMPLETED: 'appointment_completed',
    CANCELLED: 'appointment_cancelled',
    RESCHEDULED: 'appointment_rescheduled'
  },
  COMMUNICATION: {
    SMS_RECEIVED: 'sms_received',
    EMAIL_RECEIVED: 'email_received'
  }
};

export default TRACKING_EVENTS;
